import React, { useEffect, useState, useRef } from 'react'
import { useIndexedDB } from 'react-indexed-db'
import NavBar from '../NavBar'
import { useHistory } from 'react-router'
import * as tf from '@tensorflow/tfjs'
import selectBarfive from '../../../Assets/Bisoft_UI/AppMode/selectBarfive.png'
import pause from '../../../Assets/Bisoft_UI/Buttons/Active with shadow/pause_btn@3x.png'
import backY from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/back.png'
import play from '../../../Assets/Bisoft_UI/Buttons/Active with shadow/play-run@2x.png'
import cameraP5 from '../../../Assets/Bisoft_UI/AppMode/camera(speech).png'
import popupCardfive from '../../../Assets/Bisoft_UI/AppMode/popupCardfive.png'
import popupCardone from '../../../Assets/Bisoft_UI/AppMode/popupCardone.png'
import projectbig from '../../../Assets/Bisoft_UI/AppMode/projectBig.png'
import musicIcon from '../../../Assets/Bisoft_UI/AppMode/musicIcon.png'
import close from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/close.png'
import styles from '../Appmode.module.css'
import SpeechRecognition, {
    useSpeechRecognition,
} from 'react-speech-recognition'
import {
    readBytesAppMode,
    sendBytes,
} from '../../ReusableComponents/ByteTransfer/byteTransfer'
import closeBtn from '../../../Assets/img/close.png'
import Slider from 'react-slick'
import leftArrow from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/left-arrow.png'
import rightArrow from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/right-arrow.png'
import renderPrgImage from '../../../source/programImg'
import { connect } from 'react-redux'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import { textFontSize } from '../SpeechRecognition'
import '@tensorflow/tfjs-backend-webgl'
import useAudioModel from '../teachableMachine/audio/useAudioModel'
let mobilenet = undefined
let send = false
// let predict = false
// let CLASS_NAMES = []
// let classColor = []
// let trainingDataInputs = []
// let trainingDataOutputs = []
let model

function SampleNextArrow(props) {
    const { className, onClick } = props
    var style = {
        fontSize: '0',
        lineHeight: '0',
        position: 'absolute',
        top: '55%',
        display: 'block',
        padding: '0 0 0 32px',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: 'transparent',
        border: 'none',
        outline: 'none',
        background: 'transparent',
    }
    return (
        <div>
            <div
                className={'slick-arrow'}
                style={{
                    ...style,
                    // right: "-290px",
                    // height: '25%',
                    zIndex: '1000',
                    // right: '-17%',
                    left: '100%',
                    width: '25%',
                    cursor: 'default',
                }}
            >
                <img
                    src={rightArrow}
                    style={{ width: '30%', cursor: 'grab' }}
                    onClick={onClick}
                ></img>
            </div>
        </div>
    )
}

function SamplePrevArrow(props) {
    const { className, onClick } = props
    var style = {
        fontSize: '0',
        lineHeight: '0',
        position: 'absolute',
        top: '55%',
        display: 'block',
        padding: '0',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: 'transparent',
        border: 'none',
        outline: 'none',
        background: 'transparent',
    }
    return (
        <div
            className={'slick-arrow'}
            style={{
                ...style,
                left: '16%',
                display: 'block',
                width: '25%',
                zIndex: '1000',
                cursor: 'default',
            }}
        >
            <img
                src={leftArrow}
                style={{ width: '30%', cursor: 'grab', zIndex: '1000' }}
                onClick={onClick}
            ></img>
        </div>
    )
}
var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
}

const TeachableMachine = (props) => {
    const [allDetails, setAllDetails] = useState({})
    const enable = JSON.parse(sessionStorage.getItem('enable')) || { s1: {} }
    // const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'
    const connectedDevice = sessionStorage.getItem('connectedDevice') || ''
    // const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const [isPlay, setPlay] = useState(false)
    const [selectedModels, setSelectedModels] = useState([])
    const [loadedModels, setLoadedModels] = useState({})
    const [stateload, setStateload] = useState(false)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [popup, setPopup] = useState(false)
    const [regionPredictions, setRegionPredictions] = useState({})
    const [display, setDisplay] = useState(true)
    const [image, setImage] = useState(popupCardfive)
    const [detected, setDetected] = useState()
    const [text, setText] = useState({ text: 'value', size: '17px' })
    const [audioText, setAudioText] = useState({ text: '', size: '17px' })
    const [size, setSize] = useState(0)
    const [imageDetails, setImageDetails] = useState('')
    const [videoLoaded, setvideoLoaded] = useState(false)
    const [faceDetected, setFaceDetected] = useState('Unknown')
    const [results, setResults] = useState()
    const [tensors, setTensors] = useState(false)
    const [select, setSelect] = useState('None')

    const [prediction, setPrediction] = useState([])
    const [predictions, setPredictions] = useState({})
    const [isShowProcess, setIsShowProcess] = useState(false)
    // const { getAll } = useIndexedDB('SavedFaces')
    const { getByID } = useIndexedDB('ProgramData')
    const [showAllRegions, setShowAllRegions] = useState(false)
    const stabilityRef = useRef({})
    const [showPopupMessage, setShowPopupMessage] = useState(false)
    const history = useHistory()
    const MOBILE_NET_INPUT_WIDTH = 224
    const MOBILE_NET_INPUT_HEIGHT = 224
    const videoRef = React.useRef()
    const overlayRef = useRef(null)
    const interval = React.useRef()
    const readBytesInterval = React.useRef()
    const scrollRef = React.useRef(null)
    const { interimTranscript } = useSpeechRecognition()
    const [isFaceDetected, setIsFaceDetected] = useState(false)
    const startListening = () =>
        SpeechRecognition.startListening({ continuous: true })
    const [waitingToStart, setWaitingToStart] = useState(false)

    const [showPoseLines, setShowPoseLines] = useState(true)
    const [ishelpButton, sethelpButton] = useState(false)
    const [usbTxValue, setUsbTxValue] = useState(0)
    const [usbTxText, setUsbTxText] = useState('Value')
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )

    let currentModelId = props.appModeStorage.trainMachine.currentModelId
    let camModels = props.appModeStorage.trainMachine.camModels
    let currentModel = camModels.find(
        (model) => model.modelId === currentModelId
    )

    const [popupMessage, setPopupMessage] = useState('')
    const poseEnabledRef = useRef(true)
    const animationRef = useRef(null)
    const [poseDetector, setPoseDetector] = useState(null)
    const handleClickhelpbtn = () => {
        sethelpButton(true)
    }

    const hasUSBBlock = Object.values(
        JSON.parse(sessionStorage.getItem('allDetails')) || {}
    ).some((block) => block.option === 'USB')

    console.log('USB Block Present:', hasUSBBlock)
    // MoveNet keypoint connections (COCO format)
    const POSE_CONNECTIONS = [
        [0, 1],
        [0, 2],
        [1, 3],
        [2, 4], // Face
        [5, 6], // Shoulders
        [5, 7],
        [7, 9], // Left arm
        [6, 8],
        [8, 10], // Right arm
        [5, 11],
        [6, 12], // Torso
        [11, 12], // Hips
        [11, 13],
        [13, 15], // Left leg
        [12, 14],
        [14, 16], // Right leg
    ]

    const hasPoseModel = selectedModels.some((m) => m.detectionType === 'pose')
    const closeModal = () => {
        sethelpButton(false)
    }

    const lastTriggeredRef = useRef(null)
    const lastUsbTextRef = useRef(null)
    const lastUsbImageRef = useRef(null)

    // ── Audio model (runs simultaneously when mic was enabled) ────────────────
    const { classPredictions: audioClassPredictions, audioResults, audioClasses, isAudioModelLoaded } = useAudioModel({
        appModeStorage: props.appModeStorage,
        worker: props.worker,
        allDetails,
        isPlay,
        enable,
        getByID,
        onAction: (val) => {
            if (val.resolvedImage) setImage(val.resolvedImage)
            if (val.displayText) setAudioText({ text: val.displayText, size: `${textFontSize[val.selectedSize] ?? '17px'}` })
            if (enable?.s1?.pc && val.sliderOption === 'TX1' && props.worker) {
                props.worker.postMessage({ type: 'writeArray', value: [85, 83, Number(val.sliderValue)] })
            }
        },
    })

    const loadmodels = async () => {
        try {
            const URL =
                'https://tfhub.dev/google/tfjs-model/imagenet/mobilenet_v3_small_100_224/feature_vector/5/default/1'
            mobilenet = await tf.loadGraphModel(URL, { fromTFHub: true })
            setStateload(true)
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        const stored = JSON.parse(sessionStorage.getItem('allDetails')) || {}
        setAllDetails(stored)
    }, [])

    const hasPoseModels = selectedModels.some((m) => m.detectionType === 'pose')

    useEffect(() => {
        const poseReady = !hasPoseModels || poseDetector
        if (
            stateload &&
            videoLoaded &&
            selectedModels.length > 0 &&
            Object.keys(loadedModels).length > 0 &&
            poseReady &&
            select !== 'regions'
        ) {
            console.log('Starting controlled prediction loop')

            interval.current = setInterval(
                () => {
                    predictLoop()
                },
                120
            )
        }

        return () => {
            clearInterval(interval.current)
        }
    }, [
        stateload,
        videoLoaded,
        selectedModels,
        loadedModels,
        poseDetector,
        select,
        hasPoseModels,
    ])
    useEffect(() => {
        loadmodels()
    }, [])

    useEffect(() => {
        const poseReady = !hasPoseModels || poseDetector
        const assetsReady =
            stateload &&
            poseReady &&
            selectedModels.length > 0 &&
            Object.keys(loadedModels).length > 0

        if (assetsReady && waitingToStart) {
            setShowPopupMessage(false)
            setWaitingToStart(false)
            onStart()
        }
    }, [stateload, poseDetector, loadedModels, selectedModels])

    useEffect(() => {
        const loadPoseModel = async () => {
            await tf.setBackend('webgl')
            await tf.ready()

            const model = await tf.loadGraphModel(
                'https://tfhub.dev/google/tfjs-model/movenet/singlepose/lightning/4',
                { fromTFHub: true }
            )

            setPoseDetector(model)
            console.log('MoveNet loaded in TeachableMachine')
        }

        loadPoseModel()
    }, [])

    useEffect(() => {
        if (isPlay) {
            disableCam()
            enableCam()
        }
    }, [select])

    useEffect(() => {
        if (select !== 'regions' || !videoLoaded || !isPlay) return

        const drawLoop = () => {
            drawOverlay()
            animationRef.current = requestAnimationFrame(drawLoop)
        }

        drawLoop()

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current)
            }
        }
    }, [
        select,
        videoLoaded,
        isPlay,
        props.appModeStorage.trainMachine.camModels,
    ])

    useEffect(() => {
        const storedDetails =
            JSON.parse(sessionStorage.getItem('allDetails')) || {}

        // Get only modelIds used in IF blocks
        const usedModelIds = [
            ...new Set(
                Object.values(storedDetails)
                    .filter((detail) => detail.modelId)
                    .map((detail) => String(detail.modelId))
                    .filter(Boolean)
            ),
        ]

        const camModels = props.appModeStorage.trainMachine.camModels || []

        if (!camModels.length) return

        // Prefer models referenced in IF blocks; fall back to all trained models
        const filteredModels = usedModelIds.length > 0
            ? camModels.filter((model) => usedModelIds.includes(String(model.modelId)))
            : camModels

        setSelectedModels(filteredModels.length > 0 ? filteredModels : camModels)
    }, [props.appModeStorage.trainMachine.camModels])

    useEffect(() => {
        const loadSelectedModels = async () => {
            let modelsMap = {}

            const availableModels = await tf.io.listModels()

            for (const modelItem of selectedModels) {
                const hasImageClasses = Object.keys(modelItem.ImageClasses || {}).length > 0
                if (!hasImageClasses) continue

                const modelPath = `indexeddb://${modelItem.modelId}`

                if (availableModels[modelPath]) {
                    try {
                        modelsMap[modelItem.modelId] =
                            await tf.loadLayersModel(modelPath)
                    } catch (err) {
                        console.warn(
                            `Failed to load image model ${modelItem.modelId}:`, err.message
                        )
                    }
                } else {
                    console.warn(
                        `Model ${modelItem.modelId} not found in IndexedDB`
                    )
                }
            }

            setLoadedModels(modelsMap)
        }

        if (selectedModels.length) {
            loadSelectedModels()
        }
    }, [selectedModels])

    useEffect(() => {
        console.log('Selected Models State:', selectedModels)
    }, [selectedModels])

    useEffect(() => {
        const el = scrollRef.current
        if (!el) return

        const currentScroll = el.scrollTop

        requestAnimationFrame(() => {
            if (el) {
                el.scrollTop = currentScroll
            }
        })
    }, [predictions])

    useEffect(() => {
        if (!showPoseLines && overlayRef.current) {
            const canvas = overlayRef.current
            const ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)
        }
    }, [showPoseLines])

    useEffect(() => {
        if (
            stateload &&
            videoLoaded &&
            selectedModels.length > 0 &&
            Object.keys(loadedModels).length > 0 &&
            poseDetector
        ) {
        }

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current)
                animationRef.current = null
            }
        }
    }, [stateload, videoLoaded, selectedModels, loadedModels, poseDetector])

    useEffect(() => {
        props.worker.onmessage = (e) => {
            if (e.data.type === 'Appread') {
                if (!isPlay) return

                let bytes = e.data.value
                let uIndex = bytes.indexOf(85)
                if (uIndex !== -1 && bytes[uIndex + 1] === 83) {
                    const receivedValue = bytes[uIndex + 2]
                    setUsbTxValue(receivedValue)

                    Object.keys(allDetails).forEach((value) => {
                        const block = allDetails[value]

                        if (block.option !== 'USB') return

                        if (Number(block.usbValue) === Number(receivedValue)) {
                        if (block.displayText) {
                            const usbText = {
                                text: block.displayText,
                                size: `${textFontSize[block.selectedSize] ?? '17px'}`,
                            }

                            lastUsbTextRef.current = usbText

                            if (!lastTriggeredRef.current) {
                                setText(usbText)
                            }
                        }

                        if (block.image) {
                            getByID(value).then((event) => {
                                console.log('USB IMAGE SET:', event)

                                if (event?.imageURL) {
                                    lastUsbImageRef.current = event.imageURL

                                    if (!lastTriggeredRef.current) {
                                        setImage(event.imageURL)
                                    }
                                }
                            })
                        }
                    }
                })
                }
            }
        }

        return () => {
            props.worker.onmessage = null
        }
    }, [isPlay, allDetails])

    useEffect(() => {
        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current)
                animationRef.current = null
            }
        }
    }, [])

    useEffect(() => {
        poseEnabledRef.current = showPoseLines

        if (!showPoseLines && overlayRef.current) {
            const canvas = overlayRef.current
            const ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)
        }
    }, [showPoseLines])

    useEffect(() => {
        if (enable.s1.mic === true && isPlay === true) {
            setTimeout(() => {
                if (enable.s1.pc === true) {
                    props.worker.postMessage({
                        type: 'writeArray',
                        value: [85, 83, 0],
                    })
                }
                setText({ text: 'value', size: '17px' }); setAudioText({ text: '', size: '17px' })
                setImage(null)
                setResults('listening...')
            }, 1500)
        }
    }, [results, isPlay])
    let face = false
    // useEffect(() => {
    //     if (dataLoaded === true) {
    //         CLASS_NAMES = []
    //         trainingDataInputs = []
    //         trainingDataOutputs = []
    //         let count = 0

    //         Object.keys(allDetails).map((value) => {
    //             if (allDetails[value].option === 'Face Detected') {
    //                 setIsShowProcess(true)
    //                 setIsFaceDetected(true)
    //                 face = true
    //                 imageDetails.map((image) => {
    //                     if (image.id == allDetails[value].selectedObject) {
    //                         CLASS_NAMES.push(image.id)
    //                         classColor.push(
    //                             '#' +
    //                                 Math.floor(
    //                                     Math.random() * 16777215
    //                                 ).toString(16)
    //                         )
    //                         let tensors = JSON.parse(image.imagetensors)
    //                         tensors.map((tensor) => {
    //                             trainingDataInputs.push(tf.tensor(tensor))
    //                             trainingDataOutputs.push(count)
    //                         })
    //                         count += 1
    //                         console.log(
    //                             CLASS_NAMES,
    //                             trainingDataInputs,
    //                             trainingDataOutputs
    //                         )
    //                     }
    //                 })
    //             }
    //         })
    //         if (!face) {
    //             return
    //         }
    //         if (CLASS_NAMES.length === 1) {
    //             CLASS_NAMES.push('UnKnown')
    //             classColor.push(
    //                 '#' + Math.floor(Math.random() * 16777215).toString(16)
    //             )
    //             setTensors(true)
    //         } else {
    //             setTensors(true)
    //         }
    //         model = tf.sequential()
    //         model.add(
    //             tf.layers.dense({
    //                 inputShape: [1024],
    //                 units: 128,
    //                 activation: 'relu',
    //             })
    //         )
    //         model.add(
    //             tf.layers.dense({
    //                 units: CLASS_NAMES.length,
    //                 activation: 'softmax',
    //             })
    //         )

    //         model.summary()

    //         // Compile the model with the defined optimizer and specify a loss function to use.
    //         model.compile({
    //             // Adam changes the learning rate over time which is useful.
    //             optimizer: 'adam',
    //             // Use the correct loss function. If 2 classes of data, must use binaryCrossentropy.
    //             // Else categoricalCrossentropy is used if more than 2 classes.
    //             loss:
    //                 CLASS_NAMES.length === CLASS_NAMES.length
    //                     ? 'binaryCrossentropy'
    //                     : 'categoricalCrossentropy',
    //             // As this is a classification problem you can record accuracy in the logs too!
    //             metrics: ['accuracy'],
    //         })
    //     }
    // }, [dataLoaded])

    // useEffect(() => {
    //     if (!isFaceDetected) {
    //         return
    //     }
    //     if (videoLoaded === true && dataLoaded === true) {
    //         setTimeout(() => {
    //             trainAndPredict(trainingDataInputs, trainingDataOutputs)
    //         }, 2500)
    //     }
    // }, [videoLoaded, dataLoaded, isFaceDetected])

    useEffect(() => {
        if (interimTranscript !== '') {
            setResults(interimTranscript)
            let isSpeechDetectionFlag = false
            let i = null
            Object.entries(allDetails).map((ele) => {
                if (ele[1].speechText !== null && ele[1].speechText !== '') {
                    if (
                        ele[1].speechText.toLowerCase() ===
                        interimTranscript.trim().toLowerCase()
                    ) {
                        isSpeechDetectionFlag = true
                        i = ele
                    }
                }

                return null
            })

            if (isSpeechDetectionFlag && i) {
                if (allDetails[i[1].id].displayText !== null) {
                    setText({
                        text: allDetails[i[1].id]?.displayText,
                        size: `${textFontSize[allDetails[i[1]?.id]?.selectedSize] ?? '17px'}`,
                    })
                }
                if (allDetails[i[1].id].image !== null) {
                    getByID(allDetails[i[1].id].id).then((event) => {
                        setImage(event.imageURL)
                    })
                }
                if (
                    enable.s1.pc === true &&
                    allDetails[i[1].id].sliderOption === 'TX1'
                ) {
                    props.worker.postMessage({
                        type: 'writeArray',
                        value: [
                            85,
                            83,
                            Number(allDetails[i[1].id].sliderValue),
                        ],
                    })
                    send = true
                }
                setSize(allDetails[i[1].id].selectedSize)
            } else if (!isSpeechDetectionFlag) {
                setText({ text: 'value', size: '17px' }); setAudioText({ text: '', size: '17px' })

                setImage(null)

                if (enable.s1.pc === true) {
                    props.worker.postMessage({
                        type: 'writeArray',
                        value: [85, 83, 0],
                    })
                }
            }
        }
    }, [interimTranscript])

    /**
     * Captures the current frame from the webcam video,
     * resizes it to 224x224 (MobileNet input size),
     * normalizes pixel values,
     * and returns a 1024-length feature vector tensor.
     *
     * Uses tf.tidy to automatically clean up intermediate tensors.
     *
     */
    const calculateFeaturesOnCurrentFrame = (frame, roi = null) => {
        const cropped = getCroppedFrameTensor(frame, roi, [224, 224])
        if (!cropped || !mobilenet) return null

        return tf.tidy(() => {
            const floatImage = cropped.toFloat()
            const normalized = floatImage.div(255.0)
            const batched = normalized.expandDims(0)
            const features = mobilenet.execute(batched)
            return features.squeeze()
        })
    }

    // const trainAndPredict = async (trainingDataInputs, outputs) => {
    //     const advanceSetting = props.appModeStorage.trainMachine.advanceSetting
    //     console.log(CLASS_NAMES.length, trainingDataInputs, trainingDataOutputs)
    //     tf.util.shuffleCombo(trainingDataInputs, outputs)

    //     let outputsAsTensor = tf.tensor1d(outputs, 'int32')
    //     let oneHotOutputs = tf.oneHot(outputsAsTensor, CLASS_NAMES.length)
    //     let inputsAsTensor = tf.stack(trainingDataInputs)

    //     await model.fit(inputsAsTensor, oneHotOutputs, {
    //         shuffle: true,
    //         // batchSize: 5,
    //         // epochs: 10,
    //         batchSize: advanceSetting.batchSize,
    //         epochs: advanceSetting.epochs,
    //         callbacks: { onEpochEnd: logProgress },
    //     })

    //     outputsAsTensor.dispose()
    //     oneHotOutputs.dispose()
    //     inputsAsTensor.dispose()
    //     predict = true
    //     setIsShowProcess(false)

    //     // await model.save('indexeddb://myModel')
    //     // await model.save('downloads://myModel')
    //     // setPredict(true);
    //     predictLoop()
    // }

    const getCurrentPoseVector = async (frame, roi = null) => {
        if (
            !poseDetector ||
            !videoRef.current ||
            videoRef.current.videoWidth === 0 ||
            videoRef.current.videoHeight === 0
        ) {
            return null
        }

        let inputTensor = null

        // CASE 1 — Ground Mode (Polygon ROI)
        if (roi && roi.mode === 'ground' && roi.points?.length === 4) {
            inputTensor = warpGroundRegion(frame, roi, [192, 192])
            if (!inputTensor) return null
        }

        // CASE 2 — Rectangle ROI
        else if (roi) {
            const videoWidth = videoRef.current.videoWidth
            const videoHeight = videoRef.current.videoHeight

            const scaledX = roi.xPercent * videoWidth
            const scaledY = roi.yPercent * videoHeight
            const scaledW = roi.widthPercent * videoWidth
            const scaledH = roi.heightPercent * videoHeight

            const x1 = Math.max(0, scaledX)
            const y1 = Math.max(0, scaledY)
            const x2 = Math.min(videoWidth, scaledX + scaledW)
            const y2 = Math.min(videoHeight, scaledY + scaledH)

            if (x2 <= x1 || y2 <= y1) return null

            const boxes = [
                [
                    y1 / videoHeight,
                    x1 / videoWidth,
                    y2 / videoHeight,
                    x2 / videoWidth,
                ],
            ]

            inputTensor = tf.image
                .cropAndResize(frame.expandDims(0), boxes, [0], [192, 192])
                .squeeze()
        }

        // CASE 3 — Full Frame
        else {
            inputTensor = tf.image.resizeBilinear(frame, [192, 192])
        }

        return tf.tidy(() => {
            const expanded = inputTensor.expandDims(0).toInt()
            const output = poseDetector.execute(expanded)

            const keypointsTensor = Array.isArray(output) ? output[0] : output
            const keypoints = keypointsTensor.arraySync()[0][0]

            if (!keypoints) return null

            const avgConfidence =
                keypoints.reduce((sum, kp) => sum + kp[2], 0) / keypoints.length

            if (avgConfidence < 0.12) return null

            const leftHip = keypoints[11]
            const rightHip = keypoints[12]

            const centerX = (leftHip[1] + rightHip[1]) / 2
            const centerY = (leftHip[0] + rightHip[0]) / 2

            // Polygon filter
            if (roi && roi.mode === 'ground' && roi.points?.length === 4) {
                const polygon = roi.points.map((p) => ({
                    x: p.xPercent,
                    y: p.yPercent,
                }))

                const inside = isPointInsidePolygon(
                    { x: centerX, y: centerY },
                    polygon
                )

                if (!inside) return null
            }

            const torsoLength = Math.sqrt(
                Math.pow(leftHip[1] - rightHip[1], 2) +
                    Math.pow(leftHip[0] - rightHip[0], 2)
            )

            if (!torsoLength || torsoLength < 0.05) return null

            return keypoints.flatMap((kp) => [
                (kp[1] - centerX) / torsoLength,
                (kp[0] - centerY) / torsoLength,
            ])
        })
    }

    // const trainAndPredict = async (trainingDataInputs, outputs) => { ... }
    /**
     * Runs prediction loop on all selected trained models.
     *
     * For each selected model:
     *  - Extracts features from current video frame
     *  - Runs model prediction
     *  - Determines highest confidence class
     *  - Updates UI (text, image, USB TX, etc.) if confidence >= 95%
     *
     * Also updates prediction state for detection popup.
     */
    // const predictLoop = async () => {
    //     // if (predict && videoRef.current !== null) {
    //     if (videoRef.current !== null) {
    //         let detectedSomething = false
    //         // To use the modelItem instead of currentModel everywhere below
    //         for (const modelItem of selectedModels) {
    //             const model = loadedModels[modelItem.modelId]
    //             if (!model) continue

    //             tf.tidy(function () {
    //                 let imageFeatures = calculateFeaturesOnCurrentFrame()
    //                 if (imageFeatures == undefined) return
    //                 let prediction = model
    //                     .predict(imageFeatures.expandDims())
    //                     .squeeze()
    //                 let highestIndex = prediction.argMax().arraySync()
    //                 let predictionArray = prediction.arraySync()
    //                 setPredictions((prev) => {
    //                     const old = prev[modelItem.modelId]
    //                     if (
    //                         JSON.stringify(old) ===
    //                         JSON.stringify(predictionArray)
    //                     ) {
    //                         return prev
    //                     }
    //                     return {
    //                         ...prev,
    //                         [modelItem.modelId]: predictionArray,
    //                     }
    //                 })
    //                 let highestPredictionClass = Object.values(
    //                     modelItem.ImageClasses
    //                 )?.[highestIndex]
    //                 let highestPredictionClassName =
    //                     highestPredictionClass?.className ?? ''

    //                 console.log(
    //                     predictionArray,
    //                     'Prediction ' +
    //                         highestPredictionClassName +
    //                         ' with ' +
    //                         Math.floor(predictionArray[highestIndex] * 100) +
    //                         '% confidence'
    //                 )
    //                 if (Math.floor(predictionArray[highestIndex] * 100) >= 95) {
    //                     detectedSomething = true
    //                     if (!highestPredictionClass) return

    //                     const isClassUsedInIF = Object.values(allDetails).some(
    //                         (detail) =>
    //                             detail.modelId == modelItem.modelId &&
    //                             detail.selectedObject ==
    //                                 highestPredictionClass.id
    //                     )

    //                     if (!isClassUsedInIF) return
    //                     Object.keys(allDetails).map((key) => {
    //                         if (
    //                             allDetails[key].selectedObject ==
    //                             highestPredictionClass?.id
    //                         ) {
    //                             // setDetected(
    //                             //     CLASS_NAMES[highestIndex] + ' is detected'
    //                             // )
    //                             setDetected(
    //                                 highestPredictionClassName + ' is detected'
    //                             )
    //                             if (allDetails[key].displayText !== null) {
    //                                 setText({
    //                                     text: allDetails[key]?.displayText,
    //                                     size: `${textFontSize[allDetails[key]?.selectedSize] ?? '17px'}`,
    //                                 })
    //                             }
    //                             if (
    //                                 allDetails[key].image !== null &&
    //                                 allDetails[key].id
    //                             ) {
    //                                 getByID(allDetails[key].id).then(
    //                                     (event) => {
    //                                         setImage(event.imageURL)
    //                                     }
    //                                 )
    //                             }
    //                             if (
    //                                 enable.s1.pc === true &&
    //                                 allDetails[key].sliderOption === 'TX1'
    //                             ) {
    //                                 // if (
    //                                 //     deviceVersion?.startsWith('2') ||
    //                                 //     (deviceVersion?.startsWith('1') &&
    //                                 //         ['Ace'].includes(
    //                                 //             connectedDevice
    //                                 //         )) ||
    //                                 //     connectedDevice == 'Roboki'
    //                                 // ) {
    //                                 props.worker.postMessage({
    //                                     type: 'writeArray',
    //                                     value: [
    //                                         85,
    //                                         83,
    //                                         Number(allDetails[key].sliderValue),
    //                                     ],
    //                                 })
    //                                 // } else {
    //                                 //     sendBytes(
    //                                 //         [
    //                                 //             85,
    //                                 //             83,
    //                                 //             Number(
    //                                 //                 allDetails[key].sliderValue
    //                                 //             ),
    //                                 //         ],
    //                                 //         props.webSerial.port
    //                                 //     )
    //                                 // }
    //                                 send = true
    //                             }
    //                             setSize(allDetails[key].selectedSize)
    //                         }
    //                         return ''
    //                     })
    //                 }
    //                 // }
    //                 // else {
    //                 //     if (highestPredictionClass) {
    //                 //         Object.keys(allDetails).map((key) => {
    //                 //             if (
    //                 //                 allDetails[key].selectedObject ==
    //                 //                 highestPredictionClass?.id
    //                 //             ) {
    //                 //                 // setDetected(
    //                 //                 //     CLASS_NAMES[highestIndex] + ' is detected'
    //                 //                 // )
    //                 //                 setDetected(
    //                 //                     highestPredictionClassName + ' is detected'
    //                 //                 )
    //                 //                 if (allDetails[key].displayText !== null) {
    //                 //                     setText(allDetails[key].displayText)
    //                 //                 }
    //                 //                 if (allDetails[key].image !== null) {
    //                 //                     getByID(allDetails[key].id).then(
    //                 //                         (event) => {
    //                 //                             setImage(event.imageURL)
    //                 //                         }
    //                 //                     )
    //                 //                 }
    //                 //                 if (
    //                 //                     enable.s1.pc === true &&
    //                 //                     allDetails[key].sliderOption === 'TX1'
    //                 //                 ) {
    //                 //                     // if (
    //                 //                     //     deviceVersion?.startsWith('2') ||
    //                 //                     //     (deviceVersion?.startsWith('1') &&
    //                 //                     //         ['Ace'].includes(
    //                 //                     //             connectedDevice
    //                 //                     //         )) ||
    //                 //                     //     connectedDevice == 'Roboki'
    //                 //                     // ) {
    //                 //                     props.worker.postMessage({
    //                 //                         type: 'writeArray',
    //                 //                         value: [85, 83, 0],
    //                 //                     })
    //                 //                     // } else {
    //                 //                     //     sendBytes(
    //                 //                     //         [85, 83, 0],
    //                 //                     //         props.webSerial.port
    //                 //                     //     )
    //                 //                     // }
    //                 //                     send = true
    //                 //                 }
    //                 //                 setSize(allDetails[key].selectedSize)
    //                 //             }
    //                 //             return ''
    //                 //         })
    //                 //     }
    //                 // }
    //             })
    //         }
    //         if (!detectedSomething) {
    //             setDetected('Unknown is detected')
    //             setImage(popupCardfive)
    //             setText({ text: 'value', size: '17px' }); setAudioText({ text: '', size: '17px' })
    //         }
    //     }
    // }

    const predictLoop = async () => {
        if (!videoRef.current || videoRef.current.videoWidth === 0) return
        let newPredictions = {}
        let regionPredictionMap = {}
        let outsideDetected = false

        const frameTensor = tf.tidy(() =>
            tf.browser.fromPixels(videoRef.current)
        )

        let best = {
            label: null,
            confidence: 0,
            modelId: null,
            classId: null,
        }

        for (const modelItem of selectedModels) {
            const model = loadedModels[modelItem.modelId]
            if (!model) continue

            const liveDetails = allDetails || {}

            // Get all IF blocks that use this model
            const modelBlocks = Object.values(liveDetails).filter(
                (detail) => String(detail.modelId) === String(modelItem.modelId)
            )

            // Collect selected regions for this model
            const selectedRegionIds = modelBlocks
                .map((detail) => detail.selectedRegionId)
                .filter(Boolean)

            const regions = modelItem.roiRegions || []

            // ALWAYS compute full frame + all regions
            let regionList = [null, ...(regions || [])]

            for (const region of regionList) {
                let predictionArray = null

                if (modelItem.detectionType === 'pose') {
                    const poseVector = await getCurrentPoseVector(
                        frameTensor,
                        region
                    )

                    if (!poseVector) continue

                    console.log('Pose vector sample:', poseVector.slice(0, 6))

                    const poseTensor = tf.tensor(poseVector)
                    const expanded = poseTensor.expandDims()
                    try {
                        const prediction = model.predict(expanded).squeeze()
                        predictionArray = prediction.arraySync()
                        prediction.dispose()
                    } catch (err) {
                        console.warn(`[predictLoop] Pose model ${modelItem.modelId} failed:`, err.message)
                        expanded.dispose()
                        poseTensor.dispose()
                        continue
                    }
                    expanded.dispose()
                    poseTensor.dispose()
                } else {
                    const features = calculateFeaturesOnCurrentFrame(
                        frameTensor,
                        region
                    )
                    if (!features) continue

                    const expanded = features.expandDims()
                    try {
                        const prediction = model.predict(expanded).squeeze()
                        predictionArray = prediction.arraySync()
                        prediction.dispose()
                    } catch (err) {
                        console.warn(`[predictLoop] Image model ${modelItem.modelId} failed:`, err.message)
                        expanded.dispose()
                        features.dispose()
                        continue
                    }
                    expanded.dispose()
                    features.dispose()
                }

                const highestIndex = predictionArray.indexOf(
                    Math.max(...predictionArray)
                )

                const classArray = Object.values(
                    modelItem.ImageClasses || {}
                ).sort((a, b) => String(a.id).localeCompare(String(b.id)))

                const highestClass = classArray[highestIndex]
                if (!highestClass) continue

                const confidence = predictionArray[highestIndex]

                if (region) {
                    regionPredictionMap[region.id] = {
                        label: highestClass.className,
                        confidence,
                    }
                } else {
                    // Clear predictions for full frame
                }

                if (confidence > best.confidence) {
                    best = {
                        label: highestClass.className,
                        confidence,
                        modelId: modelItem.modelId,
                        classId: highestClass.id,
                        regionId: region ? region.id : null,
                    }
                }

                if (!newPredictions[modelItem.modelId]) {
                    newPredictions[modelItem.modelId] = {}
                }

                const regionKey = region ? region.id : 'full'

                newPredictions[modelItem.modelId][regionKey] = predictionArray
            }
        }

        if (Object.keys(newPredictions).length > 0) {
            setPredictions(prev => ({
                ...prev,
                ...Object.fromEntries(
                    Object.entries(newPredictions).map(([id, regionPreds]) => [
                        id,
                        { ...(prev[id] || {}), ...regionPreds },
                    ])
                ),
            }))
        }

        selectedModels.forEach((modelItem) => {
            modelItem.roiRegions?.forEach((region) => {
                region.livePrediction = regionPredictionMap[region.id] || null
            })
        })

        console.log('BEST POSE:', best.label, best.confidence)
        if (best.label && best.confidence >= 0.6) {
            const liveDetails = allDetails || {}

            console.log('BEST CLASS ID:', best.classId)
            console.log('ALL DETAILS:', liveDetails)

            const matchedBlock = Object.values(liveDetails).find((detail) => {
                const isSameModel =
                    String(detail.modelId) === String(best.modelId)

                const isSameClass =
                    String(detail.selectedObject) === String(best.classId) ||
                    String(detail.selectedClassId) === String(best.classId) ||
                    String(detail.selectedObject) === String(best.label) ||
                    String(detail.selectedClassId) === String(best.label)

                const isRegionMatch =
                    !detail.selectedRegionId ||
                    detail.selectedRegionId === 'all' ||
                    detail.selectedRegionId === 'none' ||
                    String(detail.selectedRegionId) === String(best.regionId)

                return isSameModel && isSameClass && isRegionMatch
            })
            if (matchedBlock) {
                const triggerKey = `${best.modelId}_${best.classId}`

                if (lastTriggeredRef.current !== triggerKey) {
                    lastTriggeredRef.current = triggerKey

                    setDetected(`${best.label} is detected`)

                    if (matchedBlock.displayText !== null) {
                        setText({
                            text: matchedBlock.displayText,
                            size: `${textFontSize[matchedBlock.selectedSize] ?? '17px'}`,
                        })
                    }

                    console.log('MATCHED BLOCK:', matchedBlock)

                    const blockId = Object.keys(liveDetails).find(
                        (key) => liveDetails[key] === matchedBlock
                    )

                    if (matchedBlock.image !== null && blockId) {
                        getByID(blockId).then((event) => {
                            console.log('DB IMAGE:', event)
                            if (event?.imageURL) {
                                setImage(event.imageURL)
                            }
                        })
                    }
                    if (
                        enable.s1.pc === true &&
                        matchedBlock.sliderOption === 'TX1'
                    ) {
                        props.worker.postMessage({
                            type: 'writeArray',
                            value: [85, 83, Number(matchedBlock.sliderValue)],
                        })
                    }

                    setSize(matchedBlock.selectedSize)
                }
            } else {
                if (lastTriggeredRef.current !== null) {
                    lastTriggeredRef.current = null

                    if (outsideDetected) {
                        setDetected('Unknown is detected (Outside Region)')
                    } else {
                        setDetected('Unknown is detected')
                    }

                    if (lastUsbTextRef.current) {
                        setText(lastUsbTextRef.current)
                        setImage(lastUsbImageRef.current || popupCardfive)

                        // restore USB image
                        const usbBlock = Object.values(allDetails).find(
                            (detail) =>
                                detail.displayText ===
                                    lastUsbTextRef.current.text &&
                                detail.image !== null
                        )

                        if (usbBlock?.id) {
                            getByID(usbBlock.id).then((event) => {
                                if (event?.imageURL) {
                                    lastUsbImageRef.current = event.imageURL
                                    setImage(event.imageURL)
                                } else {
                                    setImage(popupCardfive)
                                }
                            })
                        }
                    } else {
                        setText({ text: 'value', size: '17px' }); setAudioText({ text: '', size: '17px' })
                        setImage(popupCardfive)
                    }

                    if (enable.s1.pc === true) {
                        props.worker.postMessage({
                            type: 'writeArray',
                            value: [85, 83, 0],
                        })
                    }
                }
            }
        } else {
            if (lastTriggeredRef.current !== null) {
                lastTriggeredRef.current = null

                setDetected('Unknown is detected')

                if (lastUsbTextRef.current) {
                    setText(lastUsbTextRef.current)
                    setImage(lastUsbImageRef.current || popupCardfive)
                } else {
                    setImage(popupCardfive)
                    setText({ text: 'value', size: '17px' }); setAudioText({ text: '', size: '17px' })
                }

                if (enable.s1.pc === true) {
                    props.worker.postMessage({
                        type: 'writeArray',
                        value: [85, 83, 0],
                    })
                }
            }
        }
        frameTensor.dispose()
        drawOverlay()
    }

    // const reset = () => {
    //     predict = false
    //     for (let i = 0; i < trainingDataInputs.length; i++) {
    //         trainingDataInputs[i].dispose()
    //     }
    //     trainingDataInputs.splice(0)
    //     trainingDataOutputs.splice(0)
    //     console.log('Tensors in memory: ' + tf.memory().numTensors)
    // }

    const enableCam = () => {
        navigator.mediaDevices
            .getUserMedia({
                audio: false,
                video: {
                    width: { ideal: 300 },
                    height: { ideal: 225 },
                },
            })
            .then((stream) => {
                let video = videoRef.current
                video.srcObject = stream

                video.onloadedmetadata = () => {
                    video.play()

                    setTimeout(() => {
                        if (video.videoWidth > 100 && video.videoHeight > 100) {
                            setvideoLoaded(true)
                        }
                    }, 200)
                }
            })
            .catch((err) => {
                console.error('error:', err)
            })
    }

    const disableCam = () => {
        setvideoLoaded(false)

        if (videoRef.current) {
            videoRef.current.pause()

            const stream = videoRef.current.srcObject
            if (stream) {
                stream.getTracks().forEach((track) => track.stop())
            }

            videoRef.current.srcObject = null
        }

        if (enable.s1.mic === true) {
            SpeechRecognition.stopListening()
        }

        setTimeout(() => {
            setText({ text: 'value', size: '17px' }); setAudioText({ text: '', size: '17px' })
            setDetected('')
            setImage(popupCardfive)
        }, 1500)
    }

    const optionSelected = (event) => {
        const value = event.target.value

        // 🚨 If user goes back to "Select option" → STOP RUN
        if (value === 'None' || value === '' || value === 'Select option') {
            if (isPlay) {
                setPlay(false)
                setUsbTxValue(0)
                disableCam()
                clearInterval(interval.current)

                if (enable.s1.pc === true) {
                    props.worker.postMessage({
                        type: 'writeArray',
                        value: [85, 83, 0],
                    })
                    clearInterval(readBytesInterval.current)
                }
            }
        }

        setSelect(value)
    }

    const drawPose = (keypoints, canvas) => {
        const ctx = canvas.getContext('2d')

        const minConfidence = 0.2

        ctx.strokeStyle = 'blue'
        ctx.fillStyle = 'blue'
        ctx.lineWidth = 2

        // Draw skeleton lines
        POSE_CONNECTIONS.forEach(([i, j]) => {
            const kp1 = keypoints[i]
            const kp2 = keypoints[j]

            if (kp1[2] > minConfidence && kp2[2] > minConfidence) {
                ctx.beginPath()
                ctx.moveTo(kp1[1] * canvas.width, kp1[0] * canvas.height)
                ctx.lineTo(kp2[1] * canvas.width, kp2[0] * canvas.height)
                ctx.stroke()
            }
        })

        // Draw keypoints (blue dots)
        keypoints.forEach((kp) => {
            if (kp[2] > minConfidence) {
                ctx.beginPath()
                ctx.arc(
                    kp[1] * canvas.width,
                    kp[0] * canvas.height,
                    4,
                    0,
                    2 * Math.PI
                )
                ctx.fill()
            }
        })
    }

    const getCurrentPoseKeypoints = async () => {
        if (
            !poseDetector ||
            !videoRef.current ||
            videoRef.current.videoWidth === 0
        ) {
            return null
        }

        const video = videoRef.current

        return tf.tidy(() => {
            const input = tf.browser.fromPixels(video)
            const resized = tf.image.resizeBilinear(input, [192, 192])
            const expanded = resized.expandDims(0).toInt()

            const output = poseDetector.execute(expanded)
            const keypointsTensor = Array.isArray(output) ? output[0] : output
            const keypoints = keypointsTensor.arraySync()[0][0]

            return keypoints
        })
    }

    const drawOverlay = () => {
        const canvas = overlayRef.current
        const video = videoRef.current
        if (!canvas || !video) return

        const ctx = canvas.getContext('2d')

        if (video.videoWidth > 0 && video.videoHeight > 0) {
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight
        } else {
            return
        }

        const rect = video.getBoundingClientRect()
        canvas.style.width = rect.width + 'px'
        canvas.style.height = rect.height + 'px'

        ctx.clearRect(0, 0, canvas.width, canvas.height)
        // DRAW POSE IF AVAILABLE
        if (hasPoseModel && poseEnabledRef.current) {
            getCurrentPoseKeypoints().then((keypoints) => {
                if (!poseEnabledRef.current) return // 🔥 real protection
                if (keypoints) drawPose(keypoints, canvas)
            })
        }

        if (!isPlay) return

        const liveDetails = allDetails || {}

        const modelsToDraw =
            select === 'regions'
                ? props.appModeStorage.trainMachine.camModels || []
                : selectedModels

        modelsToDraw.forEach((modelItem) => {
            const regions = modelItem.roiRegions || []

            // CASE 1: SHOW ALL REGIONS
            let regionList = []

            // SHOW ALL REGIONS
            if (select === 'regions') {
                regionList = regions
            }

            // SHOW IF-BLOCK REGIONS (detected, text, usbTx)
            if (['detected', 'text', 'usbTx'].includes(select)) {
                const modelBlocks = Object.values(liveDetails).filter(
                    (detail) =>
                        String(detail.modelId) === String(modelItem.modelId)
                )

                const selectedRegionIds = modelBlocks
                    .map((detail) => detail.selectedRegionId)
                    .filter(Boolean)

                // Do NOT block drawing if 'none' exists
                if (selectedRegionIds.includes('all')) {
                    regionList = regions
                } else {
                    regionList = regions.filter((r) =>
                        selectedRegionIds.map(String).includes(String(r.id))
                    )
                }
            }

            // DRAW REGIONS
            regionList.forEach((region) => {
                let x, y, w, h

                if (region.mode === 'ground' && region.points?.length === 4) {
                    const pts = region.points.map((p) => ({
                        x: p.xPercent * canvas.width,
                        y: p.yPercent * canvas.height,
                    }))

                    ctx.beginPath()
                    ctx.moveTo(pts[0].x, pts[0].y)
                    ctx.lineTo(pts[1].x, pts[1].y)
                    ctx.lineTo(pts[2].x, pts[2].y)
                    ctx.lineTo(pts[3].x, pts[3].y)
                    ctx.closePath()

                    ctx.strokeStyle = 'yellow'
                    ctx.lineWidth = 2
                    ctx.stroke()

                    // 🔥 Create bounding box from polygon for label placement
                    x = Math.min(...pts.map((p) => p.x))
                    y = Math.min(...pts.map((p) => p.y))
                    w = Math.max(...pts.map((p) => p.x)) - x
                    h = Math.max(...pts.map((p) => p.y)) - y
                } else {
                    x = region.xPercent * canvas.width
                    y = region.yPercent * canvas.height
                    w = region.widthPercent * canvas.width
                    h = region.heightPercent * canvas.height

                    ctx.strokeStyle = 'yellow'
                    ctx.lineWidth = 2
                    ctx.strokeRect(x, y, w, h)
                }

                const fontSize = Math.max(12, canvas.width * 0.035)
                ctx.font = `${fontSize}px Arial`

                const padding = 6
                const labelText = region.name
                const textWidth = ctx.measureText(labelText).width
                const textHeight = fontSize

                // Border highlight in detected mode
                if (select === 'detected' && region.livePrediction) {
                    const confidence = Math.floor(
                        region.livePrediction.confidence * 100
                    )
                    if (confidence >= 90) {
                        ctx.strokeStyle = 'lime'
                        ctx.strokeRect(x, y, w, h)
                    }
                }

                ctx.fillStyle = 'rgba(0,0,0,0.6)'
                ctx.fillRect(
                    x + padding,
                    y + padding,
                    textWidth + 10,
                    textHeight + 6
                )

                ctx.fillStyle = 'yellow'
                ctx.fillText(
                    labelText,
                    x + padding + 5,
                    y + padding + textHeight
                )
            })
        })
    }

    const warpGroundRegion = (frame, roi, targetSize) => {
        if (!roi.points || roi.points.length !== 4) return null

        const videoWidth = videoRef.current.videoWidth
        const videoHeight = videoRef.current.videoHeight

        const src = roi.points.map((p) => [
            p.xPercent * videoWidth,
            p.yPercent * videoHeight,
        ])

        const [dstW, dstH] = targetSize

        const dst = [
            [0, 0],
            [dstW, 0],
            [dstW, dstH],
            [0, dstH],
        ]

        const pixels = frame.arraySync()

        const out = []

        for (let y = 0; y < dstH; y++) {
            const row = []

            for (let x = 0; x < dstW; x++) {
                const srcX = Math.floor(
                    src[0][0] +
                        (src[1][0] - src[0][0]) * (x / dstW) +
                        (src[3][0] - src[0][0]) * (y / dstH)
                )

                const srcY = Math.floor(
                    src[0][1] +
                        (src[1][1] - src[0][1]) * (x / dstW) +
                        (src[3][1] - src[0][1]) * (y / dstH)
                )

                if (
                    srcX >= 0 &&
                    srcY >= 0 &&
                    srcX < videoWidth &&
                    srcY < videoHeight
                ) {
                    row.push(pixels[srcY][srcX])
                } else {
                    row.push([0, 0, 0])
                }
            }

            out.push(row)
        }

        return tf.tensor(out)
    }

    const isPointInsidePolygon = (point, polygon) => {
        let inside = false
        for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const xi = polygon[i].x
            const yi = polygon[i].y
            const xj = polygon[j].x
            const yj = polygon[j].y

            const intersect =
                yi > point.y !== yj > point.y &&
                point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi

            if (intersect) inside = !inside
        }
        return inside
    }

    const getCroppedFrameTensor = (
        frame,
        roi = null,
        targetSize = [224, 224]
    ) => {
        if (
            !videoRef.current ||
            videoRef.current.videoWidth === 0 ||
            videoRef.current.videoHeight === 0
        ) {
            return null
        }

        let processed

        if (roi && roi.mode === 'ground' && roi.points?.length === 4) {
            return warpGroundRegion(frame, roi, targetSize)
        }

        if (roi) {
            const videoWidth = videoRef.current.videoWidth
            const videoHeight = videoRef.current.videoHeight

            const scaledX = roi.xPercent * videoWidth
            const scaledY = roi.yPercent * videoHeight
            const scaledW = roi.widthPercent * videoWidth
            const scaledH = roi.heightPercent * videoHeight

            const x1 = Math.max(0, scaledX)
            const y1 = Math.max(0, scaledY)
            const x2 = Math.min(videoWidth, scaledX + scaledW)
            const y2 = Math.min(videoHeight, scaledY + scaledH)

            if (x2 <= x1 || y2 <= y1) {
                return null
            }

            const boxes = [
                [
                    y1 / videoHeight,
                    x1 / videoWidth,
                    y2 / videoHeight,
                    x2 / videoWidth,
                ],
            ]

            const boxInd = [0]

            processed = tf.image
                .cropAndResize(frame.expandDims(0), boxes, boxInd, targetSize)
                .squeeze()
        } else {
            processed = tf.image.resizeBilinear(frame, targetSize)
        }

        return processed
    }

    const getDeviceName = () => {
        let deviceName = 'PC'
        switch (connectedDevice) {
            case 'Ace':
                deviceName = 'PC'
                break
            case 'Humanoid':
                deviceName = 'Zing'
                break
            case 'Hexapod':
                deviceName = 'Crawl-e'
                break
            case 'Klaw':
                deviceName = 'Klaw-b'
                break
            default:
                deviceName = connectedDevice
        }
        return deviceName
    }

    const Popup = (props) => {
        return props.trigger ? (
            <div className={styles.popup}>
                <div className={styles.popupInner}>
                    <img
                        src={close}
                        draggable="false"
                        alt="close"
                        style={{
                            position: 'absolute',
                            width: '3vw',
                            bottom: '70vh',
                            right: '-1.2vw',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            setPopup(false)
                            props.set(true)
                        }}
                    />
                </div>
                {props.displayImage !== popupCardfive ? (
                    <div style={{ zIndex: '3' }}>
                        <img
                            style={{ width: '100%', maxWidth: '60vw' }}
                            src={props.displayImage}
                            height="350vh"
                            width="350vw"
                            alt="displayImage"
                            draggable="false"
                        />
                        <p
                            style={{
                                fontSize: `${2 * Number(props.font)}vh`,
                                zIndex: '4',
                                textAlign: 'center',
                            }}
                        >
                            {props.displayText}
                        </p>
                    </div>
                ) : (
                    ''
                )}
            </div>
        ) : (
            ''
        )
    }

    const onStart = () => {
        //  Require device ONLY when both are true
        if (enable.s1.pc === true && hasUSBBlock) {
            if (!props.webSerial.port) {
                setPopupMessage('Please connect your device')
                setShowPopupMessage(true)
                return
            }
        }

        setPlay(true)
        enableCam()
    }

    return (
        <div>
            <DialogModal
                show={showPopupMessage}
                text={popupMessage}
                showCloseBtn={true}
                handleDialogModalClose={() => setShowPopupMessage(false)}
                // showCloseBtn={true}
                // handleDialogModalClose={() =>
                //     setShowModel({ isShow: false, message: '', type: '' })
                // }
                // optionsToSelect={getModelOptions(showModel.type)}
            />
            {/* NavBar */}
            <NavBar
                selectbar={selectBarfive}
                selectbarwidth="90%"
                headers={[
                    { name: 'Enable', color: 'white' },
                    { name: 'Control', color: 'white' },
                    { name: 'Run', color: 'white' },
                ]}
                showHelp={true}
                handleHelp={handleClickhelpbtn}
            />
            {/* Main */}
            <div
                className={`${
                    slideDirection === 'true' ? 'slide-right' : 'slide-left'
                }`}
                style={{ position: 'relative' }}
            >
                {' '}
                <div>
                    <img
                        src={popupCardfive}
                        draggable="false"
                        alt="popupCardfive"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '40vh',
                            left: '18vw',
                            width: '23.5vw',
                            height: '62vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={cameraP5}
                        draggable="false"
                        alt="popupCardfive"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '40vh',
                            left: '18vw',
                            width: '6vw',
                            height: '12vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={popupCardfive}
                        draggable="false"
                        alt="popupCardfive"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '50.5vh',
                            left: '51.2vw',
                            width: '26.8vw',
                            height: '39vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={popupCardone}
                        draggable="false"
                        alt="popupCardone"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '23vh',
                            left: '50.3vw',
                            width: '34vw',
                            height: '33vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={musicIcon}
                        draggable="false"
                        alt="popupCardone"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '23vh',
                            left: '45.3vw',
                            width: '7vw',
                            height: '10vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={projectbig}
                        draggable="false"
                        alt="projectbig"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '55.8vh',
                            left: '51.4vw',
                            width: '24vw',
                            height: '23vh',
                            borderWidth: 2,
                            borderColor: 'black',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: '22vh',
                            right: '25vw',
                        }}
                    >
                        <label>
                            <select
                                className={styles.selectBox}
                                style={{
                                    position: 'absolute',
                                    right: '14vw',
                                    top: '16vh',
                                    width: '19.4vw',
                                    height: '6.2vh',
                                    font: 'Halcyon Regular',
                                    fontFamily: 'Halcyon Regular',
                                    fontSize: '15px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                }}
                                onChange={optionSelected}
                                value={select}
                            >
                                <option defaultValue={'None'}>
                                    Select option
                                </option>
                                <option value="text">Text</option>
                                {enable?.s1?.mic && (
                                    <option value="audioText">Audio Text</option>
                                )}
                                {hasUSBBlock && (
                                    <option value="usbTx">
                                        {getDeviceName()} received data [USB TX]
                                    </option>
                                )}
                                <option value="detected">
                                    See all detections
                                </option>
                                <option value="regions">
                                    Show All Regions
                                </option>
                            </select>
                        </label>
                    </div>

                    {/* ── All detections popup ── */}
                    {select === 'detected' && (
                        <div
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                background: 'rgba(255, 255, 255, 0.01)',
                                
                                pointerEvents: 'auto',
                                overflow:"visible"
                            }}
                        >
                            <div
                                style={{
                                    position: 'relative',
                                    background: 'linear-gradient(to right, #f0eded, white)',
                                    borderRadius: '40px',
                                    border: '1px solid white',
                                    boxShadow: '0.5rem 0.5rem 2rem #d9d5d4',
                                    padding: '1.5rem 2rem',
                                    minWidth: '380px',
                                    maxWidth: '80vw',
                                    maxHeight: '80vh',
                                    overflow:"visible"
                                }}
                            >
                                {/* Close button */}
                                <img
                                    src={close}
                                    alt="close"
                                    draggable="false"
                                    style={{
                                        position: 'absolute',
                                        top: '-14px',
                                        right: '-14px',
                                        width: '38px',
                                        cursor: 'pointer',
                                        zIndex: 100,
                                    }}
                                    onClick={() => setSelect('None')}
                                />

                                <p
                                    style={{
                                        textAlign: 'center',
                                        fontFamily: 'Halcyon_SemiBold',
                                        fontWeight: 700,
                                        fontSize: '16px',
                                        marginBottom: '16px',
                                        color: '#333',
                                    }}
                                >
                                    Detections
                                </p>

                                <div style={{ display: 'flex', gap: '28px', flexWrap: 'wrap' }}>
                                    {/* Image detections */}
                                    <div style={{ flex: 1, minWidth: '180px' }}>
                                        <p
                                            style={{
                                                fontWeight: 700,
                                                fontSize: '13px',
                                                color: '#555',
                                                borderBottom: '1px solid #ddd',
                                                paddingBottom: '6px',
                                                marginBottom: '12px',
                                            }}
                                        >
                                            Image
                                        </p>
                                        {selectedModels.length === 0 ? (
                                            <p style={{ fontSize: '12px', color: '#999' }}>No models loaded</p>
                                        ) : selectedModels.map((modelItem) => {
                                            const classArray = Object.values(modelItem.ImageClasses || {})
                                                .sort((a, b) => String(a.id).localeCompare(String(b.id)))
                                            const predArr = predictions[modelItem.modelId]?.['full'] || []
                                            return (
                                                <div key={modelItem.modelId} style={{ marginBottom: '14px' }}>
                                                    <p style={{ fontSize: '12px', fontWeight: 600, color: '#777', marginBottom: '8px' }}>
                                                        {modelItem.modelName}
                                                    </p>
                                                    {classArray.map((cls, i) => (
                                                        <div key={i} style={{ marginBottom: '8px' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px' }}>
                                                                <span style={{ color: '#333' }}>{cls.className}</span>
                                                                <span style={{ color: '#555', fontWeight: 600 }}>
                                                                    {Math.round((predArr[i] || 0) * 100)}%
                                                                </span>
                                                            </div>
                                                            <div style={{ background: '#e4e4e4', borderRadius: '20px', height: '8px', overflow: 'hidden' }}>
                                                                <div style={{
                                                                    width: `${Math.round((predArr[i] || 0) * 100)}%`,
                                                                    height: '100%',
                                                                    background: 'linear-gradient(to right, rgb(244, 167, 86), rgb(242, 129, 104))',
                                                                    borderRadius: '20px',
                                                                    transition: 'width 0.3s ease',
                                                                }} />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )
                                        })}
                                    </div>

                                    {/* Audio detections (only when mic enabled) */}
                                    {enable?.s1?.mic === true && (
                                        <div style={{ flex: 1, minWidth: '180px' }}>
                                            <p
                                                style={{
                                                    fontWeight: 700,
                                                    fontSize: '13px',
                                                    color: '#555',
                                                    borderBottom: '1px solid #ddd',
                                                    paddingBottom: '6px',
                                                    marginBottom: '12px',
                                                }}
                                            >
                                                Audio
                                            </p>
                                            <p style={{ fontSize: '11px', color: '#888', marginBottom: '10px' }}>
                                                {isPlay ? audioResults || 'listening…' : 'Press play to start'}
                                            </p>
                                            {Object.entries(audioClassPredictions).map(([classKey, pred]) => (
                                                <div key={classKey} style={{ marginBottom: '8px' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px' }}>
                                                        <span style={{ color: '#333' }}>{pred.className}</span>
                                                        <span style={{ color: '#555', fontWeight: 600 }}>
                                                            {Math.round((pred.confidence || 0) * 100)}%
                                                        </span>
                                                    </div>
                                                    <div style={{ background: '#e4e4e4', borderRadius: '20px', height: '8px', overflow: 'hidden' }}>
                                                        <div style={{
                                                            width: `${Math.round((pred.confidence || 0) * 100)}%`,
                                                            height: '100%',
                                                            background: pred.className === 'Background_Noise'
                                                                ? '#bdbdbd'
                                                                : 'linear-gradient(to right, rgb(244, 167, 86), rgb(242, 129, 104))',
                                                            borderRadius: '20px',
                                                            transition: 'width 0.3s ease',
                                                        }} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {select === 'None' ? (
                        <></>
                    ) : (
                        <>
                            {select === 'text' && (
                                <div style={{ pointerEvents: 'none' }}>
                                    <p style={{
                                        position: 'relative',
                                        top: '53vh',
                                        left: '41.5vw',
                                        fontFamily: 'Halcyon Regular',
                                        fontSize: text.size,
                                        textAlign: 'center',
                                        maxWidth: '20vw',
                                        wordWrap: 'break-word',
                                    }}>
                                        <strong>{text.text}</strong>
                                    </p>
                                </div>
                            )}
                            {select === 'audioText' && enable?.s1?.mic && (
                                <div style={{ pointerEvents: 'none' }}>
                                    <p style={{
                                        position: 'relative',
                                        top: '53vh',
                                        left: '41.5vw',
                                        fontFamily: 'Halcyon Regular',
                                        fontSize: audioText.size,
                                        textAlign: 'center',
                                        maxWidth: '20vw',
                                        wordWrap: 'break-word',
                                    }}>
                                        <strong>{audioText.text || (isPlay ? '…listening' : 'Press play')}</strong>
                                    </p>
                                </div>
                            )}
                            {select === 'usbTx' && (
                                <div style={{
                                    position: 'relative',
                                    top: '53vh',
                                    left: '41.5vw',
                                    fontFamily: 'Halcyon Regular',
                                    fontSize: '22px',
                                    textAlign: 'center',
                                    maxWidth: '20vw',
                                    wordWrap: 'break-word',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <input
                                        style={{ border: 'none', outline: 'none', width: '150px', textAlign: 'center' }}
                                        onChange={(e) => setUsbTxText(e.target.value)}
                                        value={usbTxText}
                                    />
                                    <p style={{ marginBottom: '0', marginLeft: '15px' }}>{usbTxValue}</p>
                                </div>
                            )}
                        </>
                    )}

                    {display === true && image !== null ? (
                        <img
                            src={image}
                            draggable="false"
                            alt="displayimage"
                            style={{
                                margin: 0,
                                position: 'absolute',
                                top: '40vh',
                                left: '83vw',
                                width: '19vw',
                                height: '62vh',
                                objectFit: 'cover',
                                cursor: 'pointer',
                                borderRadius: '30px',
                                transform: 'translate(-50%, -50%)',
                            }}
                            onClick={() => {
                                setDisplay(false)
                                setPopup(true)
                            }}
                        />
                    ) : (
                        <img
                            src={popupCardfive}
                            draggable="false"
                            alt="displayimage"
                            style={{
                                margin: 0,
                                position: 'absolute',
                                top: '40vh',
                                left: '83vw',
                                width: '19vw',
                                height: '62vh',
                                transform: 'translate(-50%, -50%)',
                            }}
                        />
                    )}
                    <Popup
                        trigger={popup}
                        displayImage={image}
                        displayText={text.text}
                        font={size}
                        set={setDisplay}
                    />

                    {isPlay === true && (
                        <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            muted
                            style={{
                                position: 'absolute',
                                zIndex: '2',
                                borderRadius: '10px',
                                top: '40vh',
                                left: '18%',
                                width: '20%',
                                transform: 'translate(-50%,-50%)',
                            }}
                        />
                    )}
                    {isPlay === true ? (
                        <canvas
                            ref={overlayRef}
                            style={{
                                position: 'absolute',
                                zIndex: '3',
                                borderRadius: '10px',
                                top: '40vh',
                                left: '18%',
                                width: '20%',
                                transform: 'translate(-50%,-50%)',
                                pointerEvents: 'none',
                            }}
                        />
                    ) : (
                        <p
                            style={{
                                position: 'absolute',
                                left: '18%',
                                top: '47vh',
                                transform: 'translate(-50%,0%)',
                                font: 'Halcyon Regular',
                                fontFamily: 'Halcyon Regular',
                                fontSize: '15px',
                                textAlign: 'center',
                            }}
                        >
                            Camera Inactive
                        </p>
                    )}
                    <p
                        style={{
                            position: 'relative',
                            bottom: '-68vh',
                            right: '-17.5vw',
                            font: 'Halcyon Regular',
                            fontFamily: 'Halcyon Regular',
                            fontSize: '15px',
                            textAlign: 'center',
                            maxWidth: '400px',
                            wordWrap: 'break-word',
                            transform: 'translate(-50%,-50%)',
                        }}
                    >
                        <strong>{detected}</strong>
                    </p>
                    {/* Pose Toggle - Outside Top Left of Webcam */}
                    {isPlay && hasPoseModel && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '26vh', // aligns to webcam top
                                left: '8.2%', // 8% (camera left edge) - 4% spacing
                                zIndex: 5,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                            }}
                        >
                            <span
                                style={{
                                    fontFamily: 'Halcyon Regular',
                                    fontSize: '13px',
                                    color: '#333',
                                    fontWeight: 'bold',
                                }}
                            >
                                Pose Lines
                            </span>

                            <label className={styles.poseSwitch}>
                                <input
                                    type="checkbox"
                                    checked={showPoseLines}
                                    onChange={() =>
                                        setShowPoseLines((prev) => !prev)
                                    }
                                />
                                <span className={styles.poseSlider}></span>
                            </label>
                        </div>
                    )}
                </div>
            </div>

            {/* Footer */}
            <div>
                <img
                    src={backY}
                    draggable="false"
                    alt="back"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '92vh',
                        right: '92.7vw',
                        width: '3vw',
                        cursor: 'pointer',
                        transform: 'translate(-50%, -50%)',
                    }}
                    onClick={() => {
                        setSlideDirection(true)
                        sessionStorage.setItem('slideDirection', true)
                        if (isPlay) {
                            setPlay(false)
                            // reset()
                            disableCam()
                            clearInterval(interval.current)
                            if (enable.s1.pc === true) {
                                clearInterval(readBytesInterval.current)
                            }
                            history.push('/programmingPage')
                        } else {
                            history.push('/programmingPage')
                        }
                    }}
                />
                {/* Loading Text */}
                {!stateload && (
                    <p
                        style={{
                            position: 'absolute',
                            bottom: '8%',
                            marginLeft: '38.5%',
                            fontFamily: 'Halcyon Regular',
                            fontSize: '18px',
                            textAlign: 'center',
                        }}
                    >
                        Please wait while we are loading the assets...
                    </p>
                )}

                {/* Play / Pause Button ALWAYS visible */}
                {isPlay === false ? (
                    <img
                        id="image"
                        src={play}
                        draggable="false"
                        alt="play"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '93vh',
                            left: '95.8vw',
                            width: '4vw',
                            cursor: 'pointer',
                            transform: 'translate(-50%, -50%)',
                        }}
                        onClick={() => {
                            const assetsReady =
                                stateload &&
                                (!hasPoseModels || poseDetector) &&
                                selectedModels.length > 0 &&
                                Object.keys(loadedModels).length > 0

                            // No option selected
                            console.log('select', select)
                            if (
                                select === 'None' ||
                                select === '' ||
                                select === 'Select option'
                            ) {
                                console.log('select', select)
                                setPopupMessage(
                                    'Please select an option before running'
                                )
                                setShowPopupMessage(true)
                                return
                            }

                            // Assets not ready
                            if (!assetsReady) {
                                setPopupMessage(
                                    'Please wait while we are loading the assets...'
                                )
                                setShowPopupMessage(true)
                                setWaitingToStart(true)
                                return
                            }
                            onStart()
                        }}
                    />
                ) : (
                    <>
                        <p
                            style={{
                                position: 'absolute',
                                bottom: '10%',
                                fontFamily: 'Halcyon Regular',
                                fontSize: '18px',
                                left: '52%',
                                transform: 'translateX(-50%)',
                            }}
                        >
                            {results}
                        </p>

                        <img
                            src={pause}
                            draggable="false"
                            alt="pause"
                            style={{
                                margin: 0,
                                position: 'absolute',
                                top: '93vh',
                                left: '95.8vw',
                                width: '4vw',
                                cursor: 'pointer',
                                transform: 'translate(-50%, -50%)',
                            }}
                            onClick={() => {
                                setPlay(false)
                                setUsbTxValue(0)
                                disableCam()
                                clearInterval(interval.current)

                                if (enable.s1.pc === true) {
                                    props.worker.postMessage({
                                        type: 'writeArray',
                                        value: [85, 83, 0],
                                    })
                                    clearInterval(readBytesInterval.current)
                                }
                            }}
                        />
                    </>
                )}
            </div>
            {ishelpButton == true ? (
                <div
                    style={{
                        height: '100vh',
                        width: '100vw',
                        background: '#fff',
                        position: 'relative',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        zIndex: '100000',
                        position: 'absolute',
                    }}
                >
                    <div
                        onClick={closeModal}
                        style={{
                            borderRadius: '50%',
                            zIndex: '2000',
                            position: 'absolute',
                            top: '15%',
                            right: '18%',
                        }}
                    >
                        <img
                            src={closeBtn}
                            style={{ width: '7vh', height: 'auto' }}
                        />
                    </div>
                    <Slider
                        {...settings}
                        style={{
                            transform: 'translate(-50%,-50%)',
                            top: '46%',
                            left: '50%',
                            zIndex: '10',
                            position: 'absolute',
                        }}
                    >
                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('emotionDecH')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '54%',
                                    left: '25.4%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '2%',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '4px',
                                        fontSize: '1.8vh',
                                        textAlign: 'left',
                                        color: '#707070',
                                        fontFamily: 'Halcyon_Regular',
                                        borderRadius: '12px',
                                        marginBottom: '0px',
                                    }}
                                >
                                    Camera scene is the output window of what
                                    the web camera will see & detect
                                </p>
                            </div>
                        </div>

                        {/* <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('emotionDecH1')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '41.5%',
                                    left: '23.5%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '1.5%',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '4px',
                                        fontSize: '1.8vh',
                                        textAlign: 'left',
                                        color: '#707070',
                                        fontFamily: 'Halcyon_Regular',
                                        borderRadius: '12px',
                                        marginBottom: '0px',
                                    }}
                                >
                                    Message & values display screen show the
                                    message or values as an output for the
                                    program that is running
                                </p>
                            </div>
                        </div> */}

                        {/* <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('emotionDecH2')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '60.5%',
                                    left: '30.7%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '1.5%',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '4px',
                                        fontSize: '1.8vh',
                                        textAlign: 'left',
                                        color: '#707070',
                                        fontFamily: 'Halcyon_Regular',
                                        borderRadius: '12px',
                                        marginBottom: '0px',
                                    }}
                                >
                                    Message & values display screen show the
                                    message or values as an output for the
                                    program that is running
                                </p>
                            </div>
                        </div> */}

                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('emotionDecH3')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '55%',
                                    left: '34.8%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '2%',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '4px',
                                        fontSize: '1.8vh',
                                        textAlign: 'left',
                                        color: '#707070',
                                        fontFamily: 'Halcyon_Regular',
                                        borderRadius: '12px',
                                        marginBottom: '0px',
                                    }}
                                >
                                    The image/video output space, shows the
                                    images if any of the if condition is true
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('emotionDecH4')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '78%',
                                    left: '46.6%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '2%',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '4px',
                                        fontSize: '1.8vh',
                                        textAlign: 'left',
                                        color: '#707070',
                                        fontFamily: 'Halcyon_Regular',
                                        borderRadius: '12px',
                                        marginBottom: '0px',
                                    }}
                                >
                                    Click on this button to run the app mode.
                                    The respective action will be executed, when
                                    the if condition is true
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('emotionDecH5')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '78%',
                                    left: '56.6%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '2%',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '4px',
                                        fontSize: '1.8vh',
                                        textAlign: 'left',
                                        color: '#707070',
                                        fontFamily: 'Halcyon_Regular',
                                        borderRadius: '12px',
                                        marginBottom: '0px',
                                    }}
                                >
                                    Click on this button to stop the app mode
                                    code execution
                                </p>
                            </div>
                        </div>
            
                            {/* Audio model predictions */}
                            <div style={{ minWidth: '200px' }}>
                                <p style={{ margin: '0 0 8px', fontWeight: 'bold', fontSize: '13px', color: '#333', borderBottom: '1px solid #ddd', paddingBottom: '6px' }}>
                                    Audio Detections
                                </p>
                                <p style={{ fontSize: '12px', color: '#777', margin: '0 0 6px' }}>
                                    {isPlay ? audioResults || 'listening…' : 'Press play to start'}
                                </p>
                                {Object.entries(audioClassPredictions).map(([classKey, pred]) => (
                                    <div key={classKey} style={{ marginBottom: '4px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', marginBottom: '2px' }}>
                                            <span>{pred.className}</span>
                                            <span>{Math.round((pred.confidence || 0) * 100)}%</span>
                                        </div>
                                        <div style={{ background: '#eee', borderRadius: '4px', height: '6px', overflow: 'hidden' }}>
                                            <div style={{ width: `${Math.round((pred.confidence || 0) * 100)}%`, height: '100%', background: pred.className === 'Background_Noise' ? '#ccc' : '#4caf50', transition: 'width 0.2s ease' }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                    </Slider>
                </div>
            ) : null}
        </div>
    )
}

const mapStateToProps = (state) => {
    // console.log("mapStateToProps", state);

    return state
}
export default connect(mapStateToProps)(TeachableMachine)
